const API_CONFIG = {
  BASE_URL: process.env.REACT_APP_API_URL || 'http://localhost:8090',

  ENDPOINTS: {
    ANIMALES: '/api/animales',
    VACUNAS: '/api/vacunas',
    PESOS: '/api/pesos',
    INSEMINACIONES: '/api/inseminaciones',
  }
};

export default API_CONFIG;
